import { Box, Button, Typography } from '@mui/material';
import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { BrandIcon, BrandIconType } from '../../../BrandIcon';

type IconCardListProps = StructuredContentDocument<{
  title: string;
  subtitle?: string;
  items: Array<{
    icon: BrandIconType;
    headline?: string;
    subtext?: string;
  }>;
  cta?: {
    href: string;
    text: string;
  };
  hasBorder?: boolean;
}>;

const MAX_ITEMS = 4;

export const IconCardList = ({ props }: IconCardListProps) => {
  const { title, subtitle, items, cta, hasBorder } = props;

  return (
    <Box
      sx={{
        border: hasBorder ? '1px solid' : 'none',
        borderColor: 'neutral.lighter',
        padding: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h1">{title}</Typography>
        {subtitle ? <Typography>{subtitle}</Typography> : null}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
          justifyContent: 'center',
          rowGap: 3,
          columnGap: 2,
          width: { xs: '80%', md: 'unset' },
        }}
      >
        {items.slice(0, MAX_ITEMS).map((item, index) => (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              alignItems: 'center',
              flex: 1,
            }}
            key={index}
          >
            <BrandIcon name={item.icon} size={56} />
            <Typography variant="textBold">{item.headline}</Typography>
            {item.subtext ? <Typography>{item.subtext}</Typography> : null}
          </Box>
        ))}
      </Box>
      {cta ? (
        <Button
          sx={{
            width: 'fit-content',
          }}
          href={cta.href}
        >
          {cta.text}
        </Button>
      ) : null}
    </Box>
  );
};
